/* fx-rate.js (Phase 4, Oct 2026): the rate pages' own script (sections/fx-rate.liquid). Loaded after rates.js and fx.js.

   1. Chart tabs (7, 30, 90 days).
   2. Live repaint of every figure fx.js does not repaint: [data-fxr] elements carry the kind of price ("buy", "card", "sell",
      "remit", or "save" = cash minus card), the currency ([data-fxr-c]) and a multiplier ([data-fx-m]: 100 for prices per 100 yen,
      the amount for a cost-table cell). The value comes from window.MatrixRates (assets/rates.js), the same table the order form
      prices from. Format: as fx.js writes [data-fx-x] (Indian grouping from 100 up, 2 decimals, 4 under 1); [data-fxr-f="r"] means
      whole rupees. [data-fxr-part] splits the dial's big readout into its whole and decimal parts.
   3. The amount hint under the booking form's amount field ("≈ ₹48,345").
   Nothing here touches the order form's fields or submission: fx.js owns those. */
(function () {
  var root = document.querySelector('.r3[data-fx]');
  if (!root) return;
  var CODE = root.getAttribute('data-fx-code');

  var tabs = root.querySelectorAll('.r3-tabs [role=tab]');
  [].forEach.call(tabs, function (b) {
    b.addEventListener('click', function () {
      [].forEach.call(tabs, function (o) {
        var on = o === b, p = document.getElementById(o.getAttribute('aria-controls'));
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        if (p) p.hidden = !on;
      });
    });
  });

  function grouped(x, dp) { return x.toLocaleString('en-IN', { minimumFractionDigits: dp, maximumFractionDigits: dp }); }
  function fmt(x) { return x >= 100 ? grouped(x, 2) : (x >= 1 ? x.toFixed(2) : x.toFixed(4)); }
  function rec(code) { try { return window.MatrixRates && window.MatrixRates.get ? window.MatrixRates.get(code) : null; } catch (e) { return null; } }
  function value(r, kind) {
    if (!r) return null;
    if (kind === 'save') return (r.buy && r.card) ? r.buy - r.card : null;
    var v = r[kind];
    return (v === null || v === undefined) ? null : +v;
  }

  function paint() {
    [].forEach.call(root.querySelectorAll('[data-fxr]'), function (el) {
      var v = value(rec(el.getAttribute('data-fxr-c') || CODE), el.getAttribute('data-fxr'));
      var m = parseFloat(el.getAttribute('data-fx-m') || '1');
      if (!(v > 0) || !(m > 0)) return;
      var x = v * m, t = el.getAttribute('data-fxr-f') === 'r' ? grouped(Math.round(x), 0) : fmt(x);
      var part = el.getAttribute('data-fxr-part');
      if (part) { var bits = t.split('.'); t = part === 'w' ? bits[0] : '.' + (bits[1] || '00'); }
      el.textContent = t;
    });
    var ts = root.querySelector('[data-fxr-time]');
    if (ts && rec(CODE)) {
      var now = new Date(), ist = new Date(now.getTime() + (now.getTimezoneOffset() + 330) * 60000);
      var h = ist.getHours(), mm = ist.getMinutes();
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      ts.textContent = 'live at ' + ((h % 12) || 12) + ':' + (mm < 10 ? '0' : '') + mm + (h < 12 ? ' AM' : ' PM') + ' IST, ' +
        ist.getDate() + ' ' + months[ist.getMonth()] + ' ' + ist.getFullYear();
    }
    hint();
  }

  var amt = document.getElementById('fxf-amt'), out = root.querySelector('.r3-hint');
  function hint() {
    if (!amt || !out) return;
    var n = parseFloat((amt.value || '').replace(/[^0-9.]/g, '')) || 0, r = rec(CODE);
    var rate = r ? (r.buy || r.mid || 0) : 0;
    out.textContent = (n && rate) ? '≈ ₹' + grouped(Math.round(n * rate), 0) : '';
  }
  if (amt) amt.addEventListener('input', hint);

  if (window.MatrixRates && window.MatrixRates.onReady) window.MatrixRates.onReady(paint);
})();
